import { CURATION_STATUS } from 'domains/fast-sell-product/constants'
import * as Yup from 'yup'

const fastSellProductCurationFormSchema = Yup.object().shape({
  curation_status: Yup.string().required(
    'Curation status harus diisi'
  ),
  curation_reject_label: Yup.string().when('curation_status', {
    is   : (curation_status) => curation_status == CURATION_STATUS.REJECTED,
    then : Yup.string().required(
      'curation reject label harus diisi apabila curation status = "rejected"'
    )
  }),
  curation_reject_reason: Yup.string()
})
export default fastSellProductCurationFormSchema